<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/enterprise-branch?type=1">工作部活动</router-link></li>
                <li class="currentNode"><a>{{ title }}</a></li>
            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>工作部活动</a></li>
                    <li><router-link to="/layout/enterprise-branch?type=1" :class="{'active': type === '1'}">信息工作部</router-link></li>
                    <li><router-link to="/layout/enterprise-branch?type=2" :class="{'active': type === '2'}">双招双引工作部</router-link></li>
                    <li><router-link to="/layout/enterprise-branch?type=3" :class="{'active': type === '3'}">医药卫生工作部</router-link></li>
                    <li><router-link to="/layout/enterprise-branch?type=4" :class="{'active': type === '4'}">驻京企业工作部</router-link></li>
                </ul>
                <div class="page-content">
                    <h3>{{ title }}</h3>
                    <ul class="branch-list">
                        <li class="branch-item" v-for="branch in branchList" :key="branch.Id">
                            <img :src="branch.ImageUrl" @click="goDetail(branch)" />
                            <div class="branch-item-memo">
<!--                                <h4 class="ellipsis_two branch-item-title" @click="goDetail(branch)">{{ branch.Title }}</h4>-->
                                <el-tooltip :content="branch.Title" placement="top">
                                    <h4 class="ellipsis_two branch-item-title" @click="goDetail(branch)">{{ branch.Title }}</h4>
                                </el-tooltip>
                                <!-- <p class="ellipsis_three">{{ branch.ShopIntroduction }}</p> -->
                                <el-divider></el-divider>
                                <div class="branch-item-tip">
                                    <span class="" @click="sighUp(branch)" v-if="branch.SubTitle !== '我要报名'">{{ branch.SubTitle }}</span>
                                    <span class="doing" @click="sighUp(branch)" v-if="branch.SubTitle === '我要报名'">我要报名</span>
                                    <span class="date"><img src="@/assets/image/enterprise/time.png" /> <i>{{ branch.UpdateTime }}</i></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getActivityList,
    addBaoming
} from '@services/indexService.js';
export default {
    name:"",
    data() {
        return {
            type: "",// 信息工作部1，双招双引工作部2，医疗卫生工作部3，驻京企业工作部4
            title: "",    
            branchList:[],
            total: 0,
            currentPage: 1,
            pageSize: 9,        
        }
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
        companyId() {
            return this.$store.state.permission.companyId;
        },
        companyName() {
            return this.$store.state.permission.companyName;
        },
        loginName() {
            return this.$store.state.permission.loginName;
        }
    },
    created() {
        this.type = this.$route.query.type;
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.traverseTitle();
        this.getActivityList();
    },
    methods: {
        traverseTitle() {
            if (this.type === '1'){
                this.title = "信息工作部";
            } else if (this.type === '2'){
                this.title = "双招双引工作部";
            } else if (this.type === '3') {
                this.title = "医药卫生工作部";
            } else {
                this.title = "驻京企业工作部";
            }
        },
        getActivityList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                id: this.type
            };
            getActivityList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.branchList = res.Data;
                    this.total = res.Count;
                } else {
                    this.branchList = [];
                    this.$message.error("活动列表请求失败");
                }
            })

        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/enterprise-branch-detail',
                query: {
                    id: data.Id,
                    type: this.type,
                    page: this.currentPage,
                }
            });
            window.open(newUrl.href, '_blank');
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getActivityList();
        },
        sighUp() {
            console.log(this.accountId);
            if (!this.accountId) {
                this.$message.warning("您还没有登录，登录后方可报名！");
                return;
            }
            let param = {
                InviteCode: branch.Id,
                InviteCompanyId: this.companyId, // 报名人协会id
                CompanyName: this.companyName,  // 报名人协会id
                AccountId: this.accountId, // 报名人用户id,
                AccountName: this.loginName, // 报名人姓名
            };
            addBaoming(param).then( res => {
                if (res.Code == 1) {
                    this.$message.success(res.Message);
                } else {
                    this.$message.warning(res.Message);
                }
            })
        }
    },
    watch: {
        '$route.query.type': {
            handler: function(toType, fromType){
                console.log(toType, fromType)
                if (fromType !== undefined && toType !== fromType) {
                    this.type = toType;
                    this.currentPage = 1;
                    this.getActivityList();
                    this.traverseTitle();
                }
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content{
    padding: 30px 24px;
}
.page-content h3{
    text-align:center;
}
.branch-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    padding-bottom: 10px;
    padding-top: 10px;
}
.branch-item {
    width: 312px;
    border: 1px solid #E5E5E5;
    margin-bottom: 15px;
    margin-right: 13px;
}
.branch-list .branch-item:nth-child(3n) {
    margin-right:0;
}
.branch-item img {
    width: 312px;
    height: 196px;
    cursor: pointer;
}
.branch-item-memo h4 {
    font-family: 思源黑体 CN;
    font-size: 18px;
    color: #262626;
    margin-bottom: 10px;
    cursor: pointer;
    height: 50px;
    cursor: pointer;
}

.branch-item-memo h4:hover {
    color: #116EBA;
}
.branch-item-memo p {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #6A6A6A;
    line-height: 22px;
}
.branch-item-tip {
    display:flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
}
.branch-item-tip .doing {
    cursor: pointer;
}
.branch-item-tip .doing:hover {
    /* color: #4DC514; */
    color: #116EBA;

}
.branch-item-tip .date {
    color: #A1A8B0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.branch-item-tip .date img {
    width: 15px;
    height: 15px;
}
.branch-item-tip .date i{
    font-style: normal;
    padding-left: 6px;
}
.el-divider--horizontal {
    margin: 10px 0;
}
.branch-item-memo {
    padding: 15px;
    height: 121px;
    box-sizing: border-box;
}
</style>